export const questionQueryKeys = {
  all: ['companies'] as const,
  lists: () => [...questionQueryKeys.all, 'list'] as const,
  list: (filters: object) => [...questionQueryKeys.lists(), filters] as const,
  details: () => [...questionQueryKeys.all, 'detail'] as const,
  detail: (id: string) => [...questionQueryKeys.details(), id] as const,
};
